/**
 * ## localstore
 *
 * This module contains local this.data required for the client to manage
 * online and offline operations, including cached credentials.
 *
 * This this.data is always local to the client, and never synchronized or
 * transmitted to the Cloud.
 *
 * Everything in the this.data object is stored in a loki collection called
 * `_localstore` to avoid collisions with application this.data.
 *
 * Changes can be written directly to the `this.data` property,
 * and `flush()`ed to save to the loki collection.
 * This allows you to write many properties
 * or objects and flush() them. When the client is restarted, these flushed
 * values will automatically be written back to the .this.data object.
 *
 * ```
 * localstore.this.data.client_value = "my value";
 * localstore.flush();
 * ```
 *
 * @module client/localstore
 */

'use strict';

class Localstore {
    /**
     * Constructor. Creates a Localstore instance
     * Configured with cached credentials and offline state
     *
     * @param {Object} config - Client configuration, including credentials
     * @param {Object} db - DB object assigned to current kdclient instance
     * @return {Object} local store object
     */
    constructor(config, db) {
        this.db = db;
        this.data = this.restore();
        this.data.offline = true;
        if (!this.data.hasOwnProperty('lastsync')) {
            this.data.lastsync = 0;
        }
        this.data.lastsync = 0;
        this.data.config = config;
        this.data.credentials = config.credentials;
        this.flush(this.data);
    }

    /**
     * Restore saved user this.data from loki persistent storage
     */
    restore() {
        this.data = this.db.collections._localstore.findOne({});
        if (!this.data) {
            this.data = {};
            return this.data;
        }
        return this.data[0];
    }

    /**
     * Flush and save into the loki collection
     */
    flush() {
        this.db.collections._localstore.removeWhere({});
        this.db.collections._localstore.insert(this.data);
    }
}


module.exports = Localstore;



/** WEBPACK FOOTER **
 ** ./src/client/dal/localstore.js
 **/